import { strToXml, xmlToStr } from "./util"

export const genSld=({layernm,styletype='Point',markertype='shape',markersize=20,markeropacity=1,shapecolor='#000000',shapecode,markerWellKnownName
  ,markerdata,fontcolor='#000000',defaultfontnm='Malgun Gothic',fontnm='Malgun Gothic',fontsize=20,fontstyle='normal',usetext=false,fieldnm,strokecolor='#000000',strokewidth=2,strokedasharray=[]
  ,strokeopacity=1,fillcolor='#000000',fillopacity=1})=>{
  const parser=new DOMParser()
  const xml=strToXml(`<?xml version="1.0" encoding="UTF-8"?><StyledLayerDescriptor version="1.0.0"
    xsi:schemaLocation="http://www.opengis.net/sld http://schemas.opengis.net/sld/1.0.0/StyledLayerDescriptor.xsd"
    xmlns="http://www.opengis.net/sld" xmlns:ogc="http://www.opengis.net/ogc"
    xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance">
    <NamedLayer>
      <Name>${layernm}</Name>
      <UserStyle>
        <FeatureTypeStyle>
          <Rule></Rule>
        </FeatureTypeStyle>
      </UserStyle>
    </NamedLayer>
  </StyledLayerDescriptor>`)
  const Rule=xml.getElementsByTagName('Rule')[0]
  const Symbolizer=xml.createElement(styletype+'Symbolizer')
  Rule.appendChild(Symbolizer)
  if(styletype=='Point'){
    const Graphic=xml.createElement('Graphic')
    Symbolizer.appendChild(Graphic)
    if(markertype=='shape'){
      const Size=xml.createElement('Size')
      Size.textContent=markersize
      Graphic.appendChild(Size)
      const Mark=xml.createElement('Mark')
      Graphic.appendChild(Mark)
      const WellKnownName=xml.createElement('WellKnownName')
      if(markerWellKnownName!=null)WellKnownName.textContent=markerWellKnownName
      else WellKnownName.textContent='ttf://Material Icons#U+'+shapecode
      Mark.appendChild(WellKnownName)
      const Fill=xml.createElement('Fill')
      Mark.appendChild(Fill)
      const CssParameter=xml.createElement('CssParameter')
      CssParameter.setAttribute('name','fill')
      CssParameter.textContent=shapecolor
      Fill.appendChild(CssParameter)
      if(markeropacity!=null){
        if(markeropacity>1)markeropacity*=.01
        const Opacity=xml.createElement('Opacity')
        Opacity.textContent=markeropacity
        Graphic.appendChild(Opacity)
        const CssParameterFillOpacity=xml.createElement('CssParameter')
        CssParameterFillOpacity.setAttribute('name','fill-opacity')
        CssParameterFillOpacity.textContent=markeropacity
        Fill.appendChild(CssParameterFillOpacity)
        const CssParameterStrokeOpacity=xml.createElement('CssParameter')
        CssParameterStrokeOpacity.setAttribute('name','stroke-opacity')
        CssParameterStrokeOpacity.textContent=markeropacity
        Fill.appendChild(CssParameterStrokeOpacity)
      }
    }else if(markerdata!=null){
      const ExternalGraphic=xml.createElement('ExternalGraphic')
      Graphic.appendChild(ExternalGraphic)
      const InlineContent=xml.createElement('InlineContent')
      InlineContent.setAttribute('encoding','base64')
      const datas=markerdata.split('base64,')
      InlineContent.textContent=datas[1]
      ExternalGraphic.appendChild(InlineContent)
      datas[0]=datas[0].split(':')[1].replace(';','')
      const Format=xml.createElement('Format')
      Format.textContent=datas[0]
      ExternalGraphic.appendChild(Format)
    }
  }
  if(styletype=='Line'||styletype=='Polygon'){
    const Stroke=xml.createElement('Stroke')
    Symbolizer.appendChild(Stroke)
    if(strokecolor!=null){
      const CssParameter=xml.createElement('CssParameter')
      CssParameter.setAttribute('name','stroke')
      CssParameter.textContent=strokecolor
      Stroke.appendChild(CssParameter)
    }
    if(strokewidth!=null){
      const CssParameter=xml.createElement('CssParameter')
      CssParameter.setAttribute('name','stroke-width')
      CssParameter.textContent=strokewidth
      Stroke.appendChild(CssParameter)
    }
    if(strokeopacity!=null){
      if(strokeopacity>1)strokeopacity*=.01
      const CssParameter=xml.createElement('CssParameter')
      CssParameter.setAttribute('name','stroke-opacity')
      CssParameter.textContent=strokeopacity
      Stroke.appendChild(CssParameter)
    }
    if(strokedasharray&&strokedasharray.length){
      const CssParameter=xml.createElement('CssParameter')
      CssParameter.setAttribute('name','stroke-dasharray')
      CssParameter.textContent=strokedasharray.toString().replaceAll(',',' ')
      Stroke.appendChild(CssParameter)
    }
  }
  if(styletype=='Polygon'){
    const Fill=xml.createElement('Fill')
    Symbolizer.appendChild(Fill)
    if(fillcolor!=null){
      const CssParameter=xml.createElement('CssParameter')
      CssParameter.setAttribute('name','fill')
      CssParameter.textContent=fillcolor
      Fill.appendChild(CssParameter)
    }
    if(fillopacity!=null){
      if(fillopacity>1)fillopacity*=.01
      const CssParameter=xml.createElement('CssParameter')
      CssParameter.setAttribute('name','fill-opacity')
      CssParameter.textContent=fillopacity
      Fill.appendChild(CssParameter)
    }
  }
  if(usetext){
    const TextSymbolizer=xml.createElement('TextSymbolizer')
    Rule.appendChild(TextSymbolizer)
    const Label=xml.createElement('Label')
    TextSymbolizer.appendChild(Label)
    const PropertyName=xml.createElement('PropertyName')
    PropertyName.textContent=fieldnm
    Label.appendChild(PropertyName)
    const Font=xml.createElement('Font')
    TextSymbolizer.appendChild(Font)
    const LabelPlacement=xml.createElement('LabelPlacement')
    TextSymbolizer.appendChild(LabelPlacement)
    const PointPlacement=xml.createElement('PointPlacement')
    LabelPlacement.appendChild(PointPlacement)
    const AnchorPoint=xml.createElement('AnchorPoint')
    PointPlacement.appendChild(AnchorPoint)
    const AnchorPointX=xml.createElement('AnchorPointX')
    AnchorPointX.textContent=0.5
    AnchorPoint.appendChild(AnchorPointX)
    const AnchorPointY=xml.createElement('AnchorPointY')
    AnchorPointY.textContent=1.5
    AnchorPoint.appendChild(AnchorPointY)
    if(fontnm!=null){
      const CssParameter=xml.createElement('CssParameter')
      CssParameter.setAttribute('name','font-family')
      CssParameter.textContent=fontnm
      Font.appendChild(CssParameter)
    }
    if(fontsize!=null){
      const CssParameter=xml.createElement('CssParameter')
      CssParameter.setAttribute('name','font-size')
      CssParameter.textContent=fontsize
      Font.appendChild(CssParameter)
    }
    if(fontstyle!=null){
      const CssParameter=xml.createElement('CssParameter')
      CssParameter.setAttribute('name','font-style')
      CssParameter.textContent=fontstyle
      Font.appendChild(CssParameter)
    }
    if(fontcolor!=null){
      const Fill=xml.createElement('Fill')
      TextSymbolizer.appendChild(Fill)
      const CssParameter=xml.createElement('CssParameter')
      CssParameter.setAttribute('name','fill')
      CssParameter.textContent=fontcolor
      Fill.appendChild(CssParameter)
    }
  }
  return xmlToStr(xml)
}
